<template>
  <div>
    <ServiceInit></ServiceInit>
  </div>
</template>

<script>
import ServiceInit from "@/components/membership/service/ServiceInit.vue";

export default {
  components: {
    ServiceInit,
  },
};
</script>
